import type { OPTIONS_TIMER_TYPE } from 'commonTypes/api/scenarios/CreditOffersLoadingContent';

import type { SliceStateFromReducer } from 'shared/types';

import { findThreshold } from 'entities/scenario/lib/findThreshold';
import type { creditTimerSlice } from 'entities/scenario/model/timer/creditTimer.slice';

export type TCreditTimerState = SliceStateFromReducer<typeof creditTimerSlice>;

export const getRemainingSeconds = (state: TCreditTimerState) => state.creditTimer.remaining;
export const getTimerOptions = (state: TCreditTimerState) => state.creditTimer.options;

export const getTimerCurrentOption = (state: TCreditTimerState) => {
  const { options, remaining } = state.creditTimer;
  if (!options.length) return null;

  const thresholds = options.map((opt) => opt.showFromSecond);

  const applied = findThreshold(thresholds, remaining);

  if (!applied) {
    return null;
  }

  return options.find((opt) => opt.showFromSecond === applied) ?? null;
};

export const getTimerOptionIndexByType = (type?: OPTIONS_TIMER_TYPE) => (state: TCreditTimerState) => {
  const { options } = state.creditTimer;

  return options.findIndex((opt) => opt.type === type);
};
